/* eslint-disable camelcase */
export const self_reject = {
  'your-answer-has-been-received': 'Rahmat! Javobingiz yozib olindi',
  'do-you-want-reject-vacancy': 'Vakansiyani rad etmoqchimisiz?',
  'choose-reject-reason': 'Rad etish sababini tanlang',
  'reject-reason': 'Rad etish sababi',
  'to-reject': 'Rad etish',
};
